/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InboundCallConfigResponse } from '../models/InboundCallConfigResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class IcpService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Anrufkonfiguration für den ICP-Dienst abrufen
   * Liefert die vollständige Anrufkonfiguration für einen eingehenden Anruf.
   * Der ICP-Dienst ruft diesen Endpunkt auf, wenn ein Anruf eingeht.
   * Falls die angerufene Nummer keiner Aufgabe zugeordnet werden kann, wird 404 zurückgegeben.
   * Authentifizierung via HTTP Basic Auth (selbe Zugangsdaten wie der ICP-Dienst).
   *
   * @returns InboundCallConfigResponse Anrufkonfiguration gefunden
   * @throws ApiError
   */
  public getInboundCallConfig({
    calledPhoneNumber,
    callerPhoneNumber,
  }: {
    /**
     * Die angerufene Telefonnummer im internationalen Format (E.164)
     */
    calledPhoneNumber: string,
    /**
     * Die Telefonnummer des Anrufers im internationalen Format (E.164)
     */
    callerPhoneNumber?: string,
  }): CancelablePromise<InboundCallConfigResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/inbound/call-config',
      query: {
        'calledPhoneNumber': calledPhoneNumber,
        'callerPhoneNumber': callerPhoneNumber,
      },
      errors: {
        401: `Nicht autorisiert`,
        404: `Keine Konfiguration für die angerufene Nummer gefunden`,
      },
    });
  }

}
